module.exports = __webpack_public_path__ + "img/emptyimg.70492591.png";